var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftphoneSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "143px",
    viewBox: "0 0 99 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "content",
    fill: "#434E55",
    d: "M46.3096257,88.2747833 L75.271429,38.8229226 C81.1926065,28.7125977 92.0306849,22.5 103.747298,22.5 L120.5,22.5 L120.5,121.25 L-21.5,121.25 L-21.5,104.597706 L17.8337571,104.597706 C29.5503697,104.597706 40.3884482,98.3851082 46.3096257,88.2747833 Z",
    transform: "translate(49.500000, 71.875000) scale(-1, 1) rotate(90.000000) translate(-49.500000, -71.875000) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftphoneSidebar);
export default __webpack_public_path__ + "static/media/softphoneSidebar.2ac7c9be5c58e16b749b9388c9e573e8.svg";
export { ForwardRef as ReactComponent };